import React from 'react';

import { StepConnector as MuiStepConnector } from '@material-ui/core';

const StepConnector = props => <MuiStepConnector {...props} />

export default StepConnector;



// WEBPACK FOOTER //
// ./src/components/base/StepConnector/StepConnector.js